import FrequentTravelerRecoveryFeeModalContentContainer from './FrequentTravelerRecoveryFeeModalContentContainer';

export default FrequentTravelerRecoveryFeeModalContentContainer;
